<!-- Main container -->
<elder-basic-pane-layout class="full">
  <elder-pane>
    <elder-table
      class="flex"
      matSort
      [data]="data"
      [idField]="'id'"
      (itemClick)="openDetail($event)"
    >
      <elder-data-toolbar
        *elderTableToolbar
        (requestNew)="createNew()"
        [canRemove]="false"
        [canAdd]="true"
        [canMore]="false"
      >
      </elder-data-toolbar>

      <!-- id Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef style="width: 10%">{{ 'context.id' | translate }}</th>
        <td mat-cell *matCellDef="let conf">{{ conf.id }}</td>
      </ng-container>

      <!-- name Column -->
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef style="width: 10%">
          {{ 'context.name' | translate }}
        </th>
        <td mat-cell *matCellDef="let conf">{{ conf.nameI18n | i18nPick }}</td>
      </ng-container>

      <!-- scope Column -->
      <ng-container matColumnDef="scope">
        <th mat-header-cell *matHeaderCellDef style="width: 10%">
          {{ 'context.scope' | translate }}
        </th>
        <td mat-cell *matCellDef="let conf">{{ 'prod_list_scope.' + conf.scope | translate }}</td>
      </ng-container>

      <!-- columns conf Column -->
      <ng-container matColumnDef="columnsConf">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'positions.columns-conf.definitions' | translate }}
        </th>
        <td mat-cell *matCellDef="let conf">
          <mat-chip-set>
            @for (cd of conf?.columnsConf?.columnDefinitions; track cd) {
              <mat-chip highlighted>{{ cd?.nameI18n | i18nPick }}</mat-chip>
            }
          </mat-chip-set>
        </td>
      </ng-container>

      <!-- material list enabled Column -->
      <ng-container matColumnDef="material-list.enabled">
        <th mat-header-cell *matHeaderCellDef style="width: 10%">
          {{ 'materials.list' | translate }}
        </th>
        <td mat-cell *matCellDef="let conf">
          <mat-icon>{{
            conf?.resolveMaterialList ? 'check_box' : 'check_box_outline_blank'
          }}</mat-icon>
        </td>
      </ng-container>
    </elder-table>
  </elder-pane>
</elder-basic-pane-layout>
